import React from 'react';
import PropTypes from 'prop-types';
import { LiveAnnouncer } from 'react-aria-live';
import FederatedSolrComponentPack from './federated_solr_component_pack';
import helpers from '../helpers';
import reactT from "./reactT";
import customPending from "./results/customPending"

//import componentPack from "./component-pack";

const getFacetValues = (type, results, field, lowerBound, upperBound) => {
  return type === 'period-range-facet'
    ? (results.facets[lowerBound] || []).concat(results.facets[upperBound] || [])
    : type === 'list-facet' || type === 'range-facet'
      ? results.facets[field] || []
      : null;
};

class FederatedSolrFacetedSearch extends React.Component {
  constructor(props) {
    super(props);

    this.resetFilters = this.resetFilters.bind(this);
  }

  resetFilters() {
    let { query } = this.props;
    let searchTerm = '';
    // Keep only the value of the main search field.
    for (const field of query.searchFields) {
      if (field.field !== query.mainQueryField) {
        // Remove the field value.
        delete (field.value);
        // Collapse the sidebar filter toggle.
        field.collapse = true;
        // Collapse the terms sidebar filter toggle.
        if (Object.hasOwnProperty.call(field, 'expandedHierarchies')) {
          field.expandedHierarchies = [];
        }
      } else {
        // Extract the value of the main search term to use when setting new URL for this state.
        searchTerm = field.value;
      }
    }
    // Set new parsed params based on only search term value.
    const parsed = {
      search: searchTerm,
    };
    // Add new url to browser window history.
    helpers.qs.addNewUrlToBrowserHistory(parsed);

    // Update state to remove the filter field values.
    this.setState({ query });
    // Execute search.
    this.props.onSearchFieldChange();
  }

  render() {
    const {
      customComponents,
      bootstrapCss,
      query,
      results,
      truncateFacetListsAt,
      options,
      onSearchFieldChange,
      onTextInputChange,
      onSortFieldChange,
      onPageChange,
    } = this.props;
    const { searchFields, sortFields, rows } = query;
    const start = query.start ? query.start : 0;
    const SearchFieldContainerComponent = customComponents.searchFields.container;
    const ResultContainerComponent = customComponents.results.container;
    const ResultComponent = customComponents.results.result;
    const ResultCount = customComponents.results.resultCount;
    const ResultHeaderComponent = customComponents.results.header;
    const ResultListComponent = customComponents.results.list;
    const ResultPendingComponent = customPending;
    const PaginateComponent = customComponents.results.paginate;
    const PreloadComponent = customComponents.results.preloadIndicator;
    const CurrentQueryComponent = customComponents.searchFields.currentQuery;
    const SortComponent = customComponents.sortFields.menu;
    const FederatedTextSearch = FederatedSolrComponentPack.searchFields.text;

    const resultPending = results.pending
      ? (<ResultPendingComponent bootstrapCss={bootstrapCss} />)
      : null;

    const pagination = query.pageStrategy === 'paginate' ?
      <PaginateComponent {...this.props} bootstrapCss={bootstrapCss} onChange={onPageChange} /> :
      null;

    const preloadListItem = query.pageStrategy === 'cursor'
      && results.docs.length < results.numFound
      ? <PreloadComponent {...this.props} />
      : null;

    let pageTitle;
    if (this.props.options.pageTitle != null) {
      pageTitle = <h1>{this.props.options.pageTitle}</h1>;
    }

    return (
      <LiveAnnouncer>
        <div className="facet-filter-wrapper layout row layout-builder__layout">
          <aside className="col-lg-3 col-md-6 col-sm-12 col-12 order-md-0 d-none d-md-block sidebar-facets">
            <SearchFieldContainerComponent
              bootstrapCss={bootstrapCss}
              onNewSearch={this.resetFilters}
              resultsCount={this.props.results.numFound}
              results={this.props.results}
              categoryMapping={this.props.categoryMapping}
            >
              {/* Only render the visible facets / filters.
                  Note: their values may still be used in the query, if they were pre-set. */}
              {searchFields
                .filter(searchField => this.props.sidebarFilters.indexOf(searchField.field) > -1
                  && !searchField.isHidden)
                .map((searchField, i) => {
                  const {
                    type,
                    field,
                    lowerBound,
                    upperBound,
                  } = searchField;
                  const SearchComponent = customComponents.searchFields[type];
                  const facets = getFacetValues(type, results, field, lowerBound, upperBound);

                  // Show only subcategories for drupalSettings.filter.
                  let facetCounts = facets.filter((facet, i) => i % 2 === 1);
                  let facetValues = facets.filter((facet, i) => i % 2 === 0);
                  const categoryMapping = this.props.categoryMapping;
                  // Items to be removed from facetCounts.
                  let toRemove = new Set();
                  if (typeof drupalSettings !== 'undefined' && typeof drupalSettings.filter !== 'undefined') {
                    /*global drupalSettings:true*/
                    if (categoryMapping[drupalSettings.type] === field) {
                      for (let i = 0; i < facetValues.length; i++) {
                        let facetValue = facetValues[i];
                        // Add indecies that will be removed from facetCounts.
                        if (drupalSettings.terms_hierarchy[facetValue] !== drupalSettings.filter) {
                          toRemove.add(i);
                        }
                      }
                      // Keep only subcategories of drupalSettings.filter .
                      facetCounts = facetCounts.filter((facetCount, i) => !toRemove.has(i));
                      facetValues = facetValues.filter((facetValue, i) => drupalSettings.terms_hierarchy[facetValue] === drupalSettings.filter);
                    }
                  }
                  if (facetValues.length === 0) {
                    return null;
                  }
                  return (
                    <SearchComponent
                      key={i}
                      {...this.props}
                      {...searchField}
                      bootstrapCss={bootstrapCss}
                      facets={facets}
                      facetCounts={facetCounts}
                      facetValues={facetValues}
                      truncateFacetListsAt={truncateFacetListsAt}
                      onChange={onSearchFieldChange}
                      categoryMapping={this.props.categoryMapping}
                    />
                  );
                })
              }
            </SearchFieldContainerComponent>
          </aside>
          <div className="col-lg-9 col-md-6 col-sm-12 col-12 order-md-0 unhcr-search">
            <div className="view-content">
              {pageTitle}
              <div className="result-count-wrapper d-flex flex-column justify-content-between">
                <ResultCount
                  pending={results.pending}
                  bootstrapCss={bootstrapCss}
                  numFound={results.numFound}
                  start={start}
                  rows={rows}
                  onChange={onPageChange}
                  noResultsText={this.props.options.noResults || null}
                  termValue={searchFields.find(sf => sf.id === 'textSearchField').value}
                  solrUnavailable={results.solrUnavailable}
                />
                <a className="search-tips-btn d-flex d-xl-none" href="!#" onClick={(e) => e.preventDefault()} data-toggle="modal" data-target="#searchTips" rel="nofollow">{reactT('Search tips')}</a>
              </div>
              <div className="views-exposed-form" autoComplete="on">
                <div className="form-row">
                  <FederatedTextSearch
                    {...this.props}
                    autocomplete={options.autocomplete}
                    field={
                      searchFields.find((sf) => sf.id === "textSearchField")
                        .field
                    }
                    label=""
                    onSuggest={onTextInputChange}
                    onChange={onSearchFieldChange}
                    value={searchFields.find(sf => sf.id === 'textSearchField').value}
                  />
                  <SortComponent
                    mobile='false'
                    bootstrapCss={bootstrapCss}
                    onChange={onSortFieldChange}
                    sortFields={sortFields}
                  />
                </div>
                <CurrentQueryComponent
                  {...this.props}
                  onChange={onSearchFieldChange}
                />
              </div>
              <div className="d-block d-md-none">
                <SearchFieldContainerComponent
                  bootstrapCss={bootstrapCss}
                  onNewSearch={this.resetFilters}
                  resultsCount={this.props.results.numFound}
                  results={this.props.results}
                  categoryMapping={this.props.categoryMapping}
                >
                  {/* Only render the visible facets / filters.
                  Note: their values may still be used in the query, if they were pre-set. */}
                  <SortComponent
                    mobile='true'
                    bootstrapCss={bootstrapCss}
                    onChange={onSortFieldChange}
                    sortFields={sortFields} />
                  {searchFields
                    .filter(searchField => this.props.sidebarFilters.indexOf(searchField.field) > -1
                      && !searchField.isHidden)
                    .map((searchField, i) => {
                      const {
                        type,
                        field,
                        lowerBound,
                        upperBound,
                      } = searchField;
                      const SearchComponent = customComponents.searchFields[type];
                      const facets = getFacetValues(type, results, field, lowerBound, upperBound);

                      // Show only subcategories for drupalSettings.filter.
                      let facetCounts = facets.filter((facet, i) => i % 2 === 1);
                      let facetValues = facets.filter((facet, i) => i % 2 === 0);
                      const categoryMapping = this.props.categoryMapping;
                      // Items to be removed from facetCounts.
                      let toRemove = new Set();
                      if (typeof drupalSettings !== 'undefined' && typeof drupalSettings.filter !== 'undefined') {
                        /*global drupalSettings:true*/
                        if (categoryMapping[drupalSettings.type] === field) {
                          for (let i = 0; i < facetValues.length; i++) {
                            let facetValue = facetValues[i];
                            // Add indecies that will be removed from facetCounts.
                            if (drupalSettings.terms_hierarchy[facetValue] !== drupalSettings.filter) {
                              toRemove.add(i);
                            }
                          }
                          // Keep only subcategories of drupalSettings.filter .
                          facetCounts = facetCounts.filter((facetCount, i) => !toRemove.has(i));
                          facetValues = facetValues.filter((facetValue, i) => drupalSettings.terms_hierarchy[facetValue] === drupalSettings.filter);
                        }
                      }
                      if (facetValues.length === 0) {
                        return null;
                      }
                      return (
                        <SearchComponent
                          key={i}
                          {...this.props}
                          {...searchField}
                          bootstrapCss={bootstrapCss}
                          facets={facets}
                          facetCounts={facetCounts}
                          facetValues={facetValues}
                          truncateFacetListsAt={truncateFacetListsAt}
                          onChange={onSearchFieldChange}
                          categoryMapping={this.props.categoryMapping}
                        />
                      );
                    })
                  }
                </SearchFieldContainerComponent>
              </div>
              <p className={(searchFields.find(sf => sf.id === 'textSearchField').value || this.props.options.showEmptySearchResults) ? 'solr-search-results-container__prompt element-invisible' : 'solr-search-results-container__prompt'}>{this.props.options.searchPrompt || 'Please enter a search term.'}</p>
              <div className={(searchFields.find(sf => sf.id === 'textSearchField').value || this.props.options.showEmptySearchResults) ? 'solr-search-results-container__wrapper' : 'solr-search-results-container__wrapper element-invisible'}>
                <ResultContainerComponent bootstrapCss={bootstrapCss}>
                  <ResultHeaderComponent bootstrapCss={bootstrapCss}>
                    {resultPending}
                  </ResultHeaderComponent>
                  <ResultListComponent bootstrapCss={bootstrapCss}>
                    {results.docs.map((doc, i) => (
                      <ResultComponent
                        bootstrapCss={bootstrapCss}
                        doc={doc}
                        fields={searchFields}
                        key={doc.id || i}
                        onSelect={this.props.onSelectDoc}
                        resultIndex={i}
                        rows={rows}
                        start={start}
                        highlight={results.highlighting[doc.id]}
                        hostname={this.props.options.hostname}
                        onChange={onSearchFieldChange}
                        query={this.props.query}
                      />
                    ))}
                    {preloadListItem}
                  </ResultListComponent>
                  {pagination}
                </ResultContainerComponent>
              </div>
            </div>
          </div>
        </div>
      </LiveAnnouncer>
    );
  }
}
// Default field for publication category
let publicationCategoryField = "sm_publication_media";
if (typeof drupalSettings.publication_content_types !== 'undefined') {
  if (drupalSettings.publication_content_types === 'PDF publications only') {
    publicationCategoryField = "ss_publication_media_name";
  } else if (drupalSettings.publication_content_types === 'HTML publication pages only') {
    publicationCategoryField = "ss_publication_category";
  }
}

FederatedSolrFacetedSearch.defaultProps = {
  bootstrapCss: true,
  customComponents: FederatedSolrComponentPack,
  pageStrategy: 'paginate',
  rows: 10,
  searchFields: [
    {
      type: 'text', field: '*',
    },
  ],
  sortFields: [],
  truncateFacetListsAt: -1,
  showCsvExport: false,
  sidebarFilters: [
    "sm_site_name",
    "ss_type",
    "sm_topics",
    "ss_field_categories_list",
    "sm_tags",
    "sm_keywords",
    "ss_document_type",
    publicationCategoryField,
    "sm_event_category_media",
    "sm_countries_media",
    "ds_created",
    "ds_field_date",
    "ss_publication_category",
    "ss_supporters_category",
    "ss_event_category",
    "ss_news_category",
    "ss_field_event_type",
    "sm_countries",
    "sm_region",
  ],
  options: {},
};

FederatedSolrFacetedSearch.propTypes = {
  bootstrapCss: PropTypes.bool,
  customComponents: PropTypes.object,
  onCsvExport: PropTypes.func,
  onNewSearch: PropTypes.func,
  onPageChange: PropTypes.func,
  onSearchFieldChange: PropTypes.func.isRequired,
  onTextInputChange: PropTypes.func,
  onSelectDoc: PropTypes.func,
  onSortFieldChange: PropTypes.func.isRequired,
  query: PropTypes.object,
  results: PropTypes.object,
  showCsvExport: PropTypes.bool,
  truncateFacetListsAt: PropTypes.number,
  options: PropTypes.object,
};

export default FederatedSolrFacetedSearch;
